module.exports = __webpack_public_path__ + "static/media/bar51_thumb_even.51e7baa7.jpg";